import { CheckCircleOutlined, EditOutlined, FileExcelOutlined, ImportOutlined, StopOutlined, UsergroupAddOutlined } from "@ant-design/icons";
import { PageHeader, Popconfirm, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, HeaderActions, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import EditarAsignacionTurno from "./EditarAsignacionTurno/EditarAsignacionTurno";
import AgregarAsignacionTurno from "./AgregarAsignacionTurno/AgregarAsignacionTurno";
import AgregarAsignacionesTurnosMasivas from "./AgregarAsignacionesTurnosMasivas/AgregarAsignacionesTurnosMasivas";
import { exportarAsignacionesTurnos } from "./exportarAsignacionesTurnos";

moment.locale("es");

class AsignacionTurnos extends Component {
    tableRef = null;
    state = {
        todasAsignaciones: [],
        loading: false,
        valor: 1,
        modalAgregarAsignacionTurno: false,
        modalAgregarAsignacionesTurnosMasivas: false,
        modalEditarAsignacionTurno: false,
        modalEditarAsignacionTurnoId: null,
        exportando: false,
    };
    // Los filtros y el orden de la última consulta de la tabla, para que el Excel
    // traiga lo mismo que se ve (pero sin paginar).
    ultimosParams = {};
    consultarAsignacionesTurnos(params) {
        this.ultimosParams = params || {};
        this.setState({ loading: true });
        axios
            .post(
                "asignacionesTurnos/selectTodasAsignacionesTurnos",
                { empresaId: this.props.empresaId, ...params },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success !== 2) {
                    this.setState({ todasAsignaciones: [] });
                } else {
                    this.setState({
                        todasAsignaciones: res.data.data,
                        totalRecords: res.data.totalRecords || 0,
                    });
                }
            });
    }

    deshabilitarAsignacion(value) {
        this.setState({ loading: true });
        axios
            .post(
                "asignacionesTurnos/deshabilitarAsignacionTurno",
                { asignacionTurnoId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Asignación deshabilitada");
                } else {
                    message.error("Sucedio un error y no se pudo deshabilitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }
    habilitarAsignacion(value) {
        this.setState({ loading: true });
        axios
            .post(
                "asignacionesTurnos/habilitarAsignacionTurno",
                { asignacionTurnoId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Asignación habilitada");
                } else {
                    message.error("Sucedio un error y no se pudo habilitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    agregarAsignacionTurno() {
        this.setState({ modalAgregarAsignacionTurno: true });
    }
    cerrarAgregarAsignacionTurno() {
        this.setState({ modalAgregarAsignacionTurno: false });
        this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
    cerrarAgregarAsignacionesTurnosMasivas() {
        this.setState({ modalAgregarAsignacionesTurnosMasivas: false });
        this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
    exportarExcel() {
        const params = { ...this.ultimosParams, valor: this.state.valor };
        this.setState({ exportando: true });
        axios
            .post(
                "asignacionesTurnos/exportarAsignacionesTurnos",
                { ...params, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ exportando: false });
                if (res.data.success !== 2) {
                    message.error(res.data.message || "No se pudo exportar a Excel");
                    return;
                }
                if (!res.data.data?.length) {
                    message.info("No hay asignaciones para exportar con estos filtros");
                    return;
                }
                exportarAsignacionesTurnos({
                    asignaciones: res.data.data,
                    empresaNombre: this.props.empresaNombre,
                    valor: params.valor,
                    filters: params.filters,
                });
                if (res.data.truncado) {
                    message.warning(`El Excel trae sólo los primeros ${res.data.data.length} registros; usa los filtros para acotar`);
                }
            })
            .catch(() => {
                this.setState({ exportando: false });
                message.error("Error de conexión al exportar a Excel");
            });
    }
    editarAsignacionTurno(id) {
        this.setState({ modalEditarAsignacionTurno: true, modalEditarAsignacionTurnoId: id });
    }
    cerrarEditarAsignacionTurno() {
        this.setState({ modalEditarAsignacionTurno: false });
        this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }

    render() {
        const columns = [
            {
                title: "Número",
                dataIndex: "numero",
                key: "numero",
                buscar: "serieNumero",
                render: (value,record) => `${record.serie} - ${record.numero}`,
                width: "6%",
            },
            {
                title: "Empleado",
                dataIndex: "empleadoNombre",
                key: "empleadoNombre",
                buscar: "empleadoNombre",
                width: "18%",
            },
            {
                title: "Inicio",
                dataIndex: "inicio",
                key: "inicio",
                render: (value) => value ? moment(value).format("DD/MM/YYYY") : "—",
                width: "18%",
            },
            {
                title: "Fin",
                dataIndex: "fin",
                key: "fin",
                render: (value) => value ? moment(value).format("DD/MM/YYYY") : "—",
                width: "18%",
            },
            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                width: "8%",
                render: (value) => {
                    if (value === 0) return <Tag color="red">Cancelado</Tag>;
                    if (value === 1) return <Tag color="green">Activo</Tag>;
                    if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
                    return "—";
                },
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                width: "10%",
                render: (value, record) => {
                    let buttons = [];

                    if (this.props.permisoEditarAsignacionTurno) {
                        buttons.push(
                            <Tooltip
                                title="Editar Asignación de Turno"
                                placement="top"
                                overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                            >
                                <ButtonItem
                                    key={`editar-${record._id}`}
                                    type="default"
                                    size="small"
                                    cyan
                                    icon={<EditOutlined />}
                                    onClick={() => this.editarAsignacionTurno(record._id)}
                                >
                                </ButtonItem>
                            </Tooltip>
                        );
                    }

                    if (this.props.permisoDeshabilitarAsignacionTurno) {
                        if (record.estado === 1) {
                            buttons.push(
                                <Popconfirm
                                    key={`deshabilitar-${record._id}`}
                                    title="¿Seguro que quieres deshabilitar esta asignación de turno?"
                                    onConfirm={() => this.deshabilitarAsignacion(record._id)}
                                    okText="Sí"
                                    cancelText="No"
                                >
                                    <Tooltip
                                        title="Deshabilitar"
                                        placement="top"
                                        overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                    >
                                        <ButtonItem
                                            type="default"
                                            size="small"
                                            lima
                                            icon={<CheckCircleOutlined />}
                                        >
                                        </ButtonItem>
                                    </Tooltip>
                                </Popconfirm>
                            );
                        } else {
                            buttons.push(
                                <Popconfirm
                                    key={`habilitar-${record._id}`}
                                    title="¿Seguro que quieres habilitar esta asignación de turno?"
                                    onConfirm={() => this.habilitarAsignacion(record._id)}
                                    okText="Sí"
                                    cancelText="No"
                                >
                                    <Tooltip
                                        title="Habilitar"
                                        placement="top"
                                        overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                    >
                                        <ButtonItem
                                            type="default"
                                            size="small"
                                            rojo
                                            icon={<StopOutlined />}
                                        >
                                        </ButtonItem>
                                    </Tooltip>
                                </Popconfirm>
                            );
                        }
                    }

                    return <div className="acciones-container">{buttons}</div>;
                }
            },
        ];


        return (
            <>
                <PageHeader
                    title="Asignación de Turnos"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            {window.innerWidth > 1000 &&
                                <SegmentedItem
                                    options={[{ label: 'Vigente', value: 1 }, { label: 'Deshabilitada', value: 2 }, { label: 'Todos', value: 3 }]}
                                    onChange={(value) => {
                                        if (this.tableRef) {
                                            this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                                        }
                                        this.setState({ valor: value });
                                    }}
                                    value={this.state.valor}
                                />
                            }
                            {/* Todo lo de aquí adentro va en el menú de los tres puntitos, como en Insumos */}
                            <HeaderActions>
                                {this.props.permisoAgregarAsignacionTurno && (
                                    <ButtonItem
                                        type="default"
                                        key="agregarAsignacionesTurnosMasivas"
                                        icon={<UsergroupAddOutlined />}
                                        verde
                                        onClick={() => this.setState({ modalAgregarAsignacionesTurnosMasivas: true })}
                                    >
                                        Agregar Varias
                                    </ButtonItem>
                                )}
                                {this.props.permisoAgregarAsignacionTurno && (
                                    <ButtonItem
                                        type="default"
                                        key="importarAsignacionTurnos"
                                        icon={<ImportOutlined />}
                                        onClick={() => this.props.history.push("/panel/importarAsignacionTurnos")}
                                    >
                                        Importar / Descargar Excel
                                    </ButtonItem>
                                )}
                                <ButtonItem
                                    type="default"
                                    key="exportarAsignacionTurnos"
                                    icon={<FileExcelOutlined />}
                                    azulMarino
                                    loading={this.state.exportando}
                                    onClick={this.exportarExcel.bind(this)}
                                >
                                    Exportar a Excel
                                </ButtonItem>
                            </HeaderActions>
                            {this.props.permisoAgregarAsignacionTurno && (
                                <ButtonItem
                                    type="primary"
                                    key="agregarAsignacionTurno"
                                    onClick={this.agregarAsignacionTurno.bind(this)}
                                >
                                    Agregar Asignación de Turno
                                </ButtonItem>
                            )}
                        </div>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    loading={this.state.loading}
                    onFetchData={this.consultarAsignacionesTurnos.bind(this)}
                    anadirValorFiltro={this.state.valor}
                    size="small"
                    onlyMineFilter
                    dataSource={this.state.todasAsignaciones}
                    columns={columns}
                    scroll={{ x: "max-content" }}
                    filterStorageKey={"asignacionesTurnos" + this.props.empresaId}
                    onRow={(record) => ({
                        onDoubleClick: () => {
                            if (this.props.permisoEditarAsignacionTurno) {
                                this.editarAsignacionTurno(record._id);
                            }
                        },
                    })}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={1}
                />
                <AgregarAsignacionTurno
                    visible={this.state.modalAgregarAsignacionTurno}
                    cerrarAgregarAsignacionTurno={this.cerrarAgregarAsignacionTurno.bind(this)}
                />
                <AgregarAsignacionesTurnosMasivas
                    visible={this.state.modalAgregarAsignacionesTurnosMasivas}
                    cerrarAgregarAsignacionesTurnosMasivas={this.cerrarAgregarAsignacionesTurnosMasivas.bind(this)}
                />
                <EditarAsignacionTurno
                    visible={this.state.modalEditarAsignacionTurno}
                    asignacionTurnoId={this.state.modalEditarAsignacionTurnoId}
                    cerrarEditarAsignacionTurno={this.cerrarEditarAsignacionTurno.bind(this)}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        empresaNombre: state.empresa.nombre,
        permisoAgregarAsignacionTurno: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f021de7899dda241377cf4")?.activado,
        permisoEditarAsignacionTurno: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f021ea7899dda241377cf5")?.activado,
        permisoDeshabilitarAsignacionTurno: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f021f77899dda241377cf6")?.activado,
    };
};

export default connect(mapStateToProps)(AsignacionTurnos);
